import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getABooking,
  updateABooking,
} from "../features/booking/bookingSlice";
import { BiArrowBack } from "react-icons/bi";

const ViewWaterRefillBookings = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const getBookingId = location.pathname.split("/")[3];

  const bookingState = useSelector((state) => state.booking);
  const booking =
    bookingState?.booking ||
    bookingState?.bookings?.find((b) => b._id === getBookingId);

  useEffect(() => {
    dispatch(getABooking(getBookingId));
  }, [getBookingId, dispatch]);

  const goBack = () => {
    navigate(-1);
  };

const setBookingStatus = async (status, id) => {
  await dispatch(updateABooking({ id, bookingData: status }));
  dispatch(getABooking(id));
};

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center">
        <h3 className="mb-4 title">View Water Refill Booking</h3>

        <button
          className="bg-transparent back-button border-0 fs-6 mb-0 d-flex align-items-center gap-1"
          onClick={goBack}
        >
          <BiArrowBack className="fs-5 back-icon" /> Go Back
        </button>
      </div>

      <div className="view-booking-wrapper">
        <div className="view-booking-content">
          <div className="bg-white p-4 d-flex gap-3 flex-column rounded-3">

            {/* ================= BOOKING DETAILS ================= */}
            <h4>Water Refill Details</h4>

            <table className="table table-bordered">
              <tbody>
                <tr>
                  <th>Service Type</th>
                  <td>{booking?.serviceType || "N/A"}</td>
                </tr>

                <tr>
                  <th>Litres</th>
                  <td>
                    {booking?.litres ? `${booking.litres} L` : "N/A"}
                  </td>
                </tr>

                <tr>
                  <th>Number of Containers</th>
                  <td>{booking?.numberOfContainers || "N/A"}</td>
                </tr>

                <tr>
                  <th>Preferred Delivery Date</th>
                  <td>
                    {booking?.preferredDate
                      ? new Date(booking.preferredDate).toLocaleDateString()
                      : "N/A"}
                  </td>
                </tr>

                <tr>
                  <th>Preferred Delivery Time</th>
                  <td>{booking?.preferredTime || "N/A"}</td>
                </tr>

                <tr>
                  <th>Price</th>
                  <td>
                    KSh {Number(booking?.price || 0).toLocaleString()}
                  </td>
                </tr>

                <tr>
                  <th>Status</th>
                  <td>{booking?.status || "N/A"}</td>
                </tr>

                <tr>
                  <th>Read</th>
                  <td>{booking?.read ? "Yes" : "No"}</td>
                </tr>
              </tbody>
            </table>

            {/* ================= CUSTOMER DETAILS ================= */}
            <h4>Customer Details</h4>

            <table className="table table-bordered">
              <tbody>
                <tr>
                  <th>Name</th>
                  <td>{booking?.name || "N/A"}</td>
                </tr>

                <tr>
                  <th>Phone</th>
                  <td>
                    {booking?.phone ? (
                      <a href={`tel:${booking.phone}`}>
                        {booking.phone}
                      </a>
                    ) : (
                      "N/A"
                    )}
                  </td>
                </tr>

                <tr>
                  <th>Email</th>
                  <td>
                    {booking?.email ? (
                      <a href={`mailto:${booking.email}`}>
                        {booking.email}
                      </a>
                    ) : (
                      "N/A"
                    )}
                  </td>
                </tr>
              </tbody>
            </table>

            {/* ================= DELIVERY LOCATION ================= */}
            <h4>Delivery Location</h4>

            <table className="table table-bordered">
              <tbody>
                <tr>
                  <th>Apartment / Estate</th>
                  <td>{booking?.apartment || "N/A"}</td>
                </tr>

                <tr>
                  <th>House Number</th>
                  <td>{booking?.houseNumber || "N/A"}</td>
                </tr>

                <tr>
                  <th>Location Notes</th>
                  <td>{booking?.locationNotes || "N/A"}</td>
                </tr>

                <tr>
                  <th>Additional Notes</th>
                  <td>{booking?.notes || "N/A"}</td>
                </tr>
              </tbody>
            </table>

            {/* ================= STATUS CHANGE ================= */}
           <div className="status-select-wrapper">
            <select
                value={booking?.status || "New"}
                className={`status-select status-${(booking?.status || "new").toLowerCase()}`}
                onChange={(e) =>
                setBookingStatus(e.target.value, getBookingId)
                }
            >
                <option value="New">New</option>
                <option value="Contacted">Contacted</option>
                <option value="Completed">Completed</option>
                <option value="Cancelled">Cancelled</option>
            </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewWaterRefillBookings;